import React, { Fragment } from 'react'
import { useShared } from '../../hooks/useShared'
import MainSection from '../../components/sections/MainSection';


const TABLE_HEAD = ["#", "شزکت", 'نوع کارت', 'مقدار پول به افغانی', 'تاريخ'];
const breadcrumbs = [{ name: 'کارت‌ها عضويت', link: '/card_membership' }]


const searchInputFields = [
    { label: 'شرکت', name: 'name', type: 'text', roles: [1], icon: 'text-outline', className: 'md:col-span-2' },
    { label: 'کارت', name: 'card', type: 'select', roles: [1], icon: 'text-outline', className: 'md:col-span-2', options: [] },
    { label: 'مقدار پول', name: 'amount', type: 'text', roles: [1], icon: 'book-outline', className: 'md:col-span-2' },
];


export default function CardMembership() {

    const { com, models, } = useShared();


    const getTableData = () => {
        const data = models?.data
        return (<><tbody className=''>

            {data?.map((r, i) => {
                return (<Fragment key={r.id}>
                    {i <= data?.length - 1 && <tr key={r.id} >
                        <td >{models?.from + i}</td>
                        <th className=' px-2'>{r?.company ? r?.company?.name_af : r?.name}</th>

                        <td >
                            {r?.items?.map((item, j) => {
                                return <span key={j} className='ml-1'>{item?.category?.label}{j < r?.items?.length - 1 && <span >،</span>} </span>
                            })}

                        </td>

                        <td> {com.NumberFormatter(r?.amount)} ؋</td>


                        <td style={{ direction: 'ltr' }} className='w-[20%]'>{com.dateConvert(r?.created_at, false, true)}</td>


                    </tr>}</Fragment>

                )
            })}

        </tbody> <tfoot>
                {data?.length > 0 && <tr className='border' key={data[data?.length - 1]?.id}>
                    <th className="bg-purple-500/20 text-purple-900"> توتال</th>
                    <th colSpan={7} className=" bg-green-400/30 text-green-900 text-lg font-bold">{com.NumberFormatter(data[data?.length - 1]?.amount)} ؋</th>
                </tr>}
            </tfoot>
        </>)
    }


    return (
        <MainSection v={{
            searchInputFields,
            TABLE_HEAD,
            breadcrumbs,
            tableData: getTableData(),
            tableTitle: 'لست کارت‌ها عضويت',
            url: "card_membership",
            mUrl: { getAll: 'card_membership' },
            searchData: {},
        }} />
    )
}
